<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-8">
                  <h4 class="card-title">Bonus Yükleme Yardımcısı</h4>
                  <p class="card-category">Bonus yükleme için burayı kullanınız. Bayi ayarları ve müşteri ayarları
                    üzerindeki bonus ayarlarına göre, vermeniz gereken bonusu otomatik olarak hesaplayacaktır.</p>
                </div>

              </div>

              <div class="row m-5 justify-content-center align-items-center">
                <h2>Zaman Dilimi</h2>
                <div class="col-12 d-flex justify-content-center align-items-center">
                  <button class="btn mr-2 mb-2" v-for="timePeriod in timePeriods" :key="timePeriod.id"
                    @click="selectTimePeriod(timePeriod.id)"
                    :class="{ 'btn-primary btn-fill': selectedTimePeriod === timePeriod.id, 'btn-outline-primary': selectedTimePeriod !== timePeriod.id }">
                    {{ timePeriod.title }}
                  </button>
                </div>
              </div>

              <div class="row m-5 justify-content-center align-items-center">
                <div class="col-12 d-flex justify-content-center align-items-center">

                  <button class="btn mr-2 mb-2"
                    :class="{ 'btn-primary btn-fill': selectedDealerId === null, 'btn-outline-primary': selectedDealerId !== null }"
                    @click="selectDealer(null)">Tüm Bayiiler</button>

                  <button class="btn mr-2 mb-2" v-for="dealer in dealers" :key="dealer._id"
                    @click="selectDealer(dealer._id)"
                    :class="{ 'btn-primary btn-fill': selectedDealerId === dealer._id, 'btn-outline-primary': selectedDealerId !== dealer._id }">
                    {{ dealer.title }} ({{ dealer.code }})
                  </button>
                </div>
              </div>

              <!-- Yeni hafta veya ay seçim alanı -->
              <div v-if="selectedTimePeriod === 'weekly'" class="row m-3 justify-content-center align-items-center">
                <div class="col-4">
                  <select class="form-control" v-model="selectedWeek" @change="getCustomers">
                    <option v-for="week in weeks" :key="week.id" :value="week.value">
                      {{ week.title }}
                    </option>
                  </select>
                </div>
              </div>

              <div v-if="selectedTimePeriod === 'monthly'" class="row m-3 justify-content-center align-items-center">
                <div class="col-4">
                  <select class="form-control" v-model="selectedMonth" @change="getCustomers">
                    <option v-for="month in months" :key="month.id" :value="month.value">
                      {{ month.title }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row p-3">
                <div class="col-3 ml-2">
                  <input class="form-control form-control-lg bg-light text-dark " @input="debounceGetCustomers"
                    v-model="queryText" type="text" placeholder="Arama">
                </div>

              </div>


            </template>
            <h3 v-if="selectedTimePeriod === 'weekly' && selectedWeek" class="text-center" style="font-weight: bold;">
              Gösterilen
              Veriler, {{
                weeks.find(week =>
                  week.value === selectedWeek).title}} isimli hafta için verilerdir.</h3>
            <h3 v-if="selectedTimePeriod === 'monthly' && selectedMonth" class="text-center" style="font-weight: bold;">
              Gösterilen
              Veriler, {{
                months.find(month =>
                  month.value === selectedMonth).title}} isimli ay için verilerdir.</h3>

            <h3 class="text-center" style="font-weight: bold;">Bonus hesaplamaları, kullanıcı üzerinde bonus ayarı varsa
              onun üzerinden, eğer yok ise bayii üzerindeki bonus ayarına göre hesaplanır.</h3>


            <div v-if="customersLoading === true">
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title text-center">Yükleniyor...</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="container-fluid" style="border-top: 5px solid black;" v-if="customersLoading === false">

              <h1 v-if="customers.filter(customer => customer.reportBonus).length == 0" class="text-center"
                style="font-weight: bold;">Aya ait Raporların Yüklenmesi Bekleniyor</h1>

              <!-- Data Rows -->
              <div v-for="customer in customers.filter(customer => customer.reportBonus.length > 0)" :key="customer._id"
                class="row py-2 hover-highlight bg-gray" style="border-bottom: 5px solid black;">

                <!-- Müşteri Genel Bilgileri -->
                <div class="col-12 row mb-3">
                  <div class="col-3">
                    <label style="font-weight: bold; color: black;">Müşteri Bilgileri</label>
                    <div><a :href="'/#/admin/customers/' + customer._id" target="_blank"
                        style="text-decoration: none; color: black;"><b>Ad Soyad:</b> {{ customer.name }} {{
                          customer.surname }}</a></div>
                    <div><b>GSM:</b> {{ customer.gsm }}</div>
                    <div><b>Tel:</b> {{ customer.fullPhone }}</div>
                  </div>

                  <div class="col-3">
                    <label style="font-weight: bold; color: black;">Bayii</label>
                    <div>{{ customer.dealer ? customer.dealer.title + ' (' + customer.dealer.code + ')' : '-' }}</div>
                    <label style="font-weight: bold; color: black;">Grup</label>
                    <div>{{ customer.affiliateGroup ? customer.affiliateGroup.title + ' (' +
                      customer.affiliateGroup.code + ')' :
                      '-' }}</div>
                  </div>


                  <div class="col-6">
                    <label style="font-weight: bold; color: black;">{{ selectedTimePeriod === 'monthly' ? 'Aylık' :
                      'Haftalık' }}
                      Toplam Özet</label>
                    <div class="row">
                      <div class="col-4">
                        <small>Toplam Yükleme</small>
                        <div class="h4 font-weight-bold">{{customer.totalDeposit.length > 0 ?
                          numeral(customer.totalDeposit.reduce((acc, curr) => acc + curr.totalAmount,
                            0)).format('0,0.00') + ' TL' :
                          '-'}}</div>
                      </div>
                      <div class="col-4">
                        <small>Toplam Çevirim</small>
                        <div class="h4 font-weight-bold">{{customer.totalConversion.length > 0 ?
                          numeral(customer.totalConversion.reduce((acc, curr) => acc + curr.totalAmount,
                            0)).format('0,0.00') + ' TL' : '-'}}</div>
                        <small>Toplam İade </small>
                        <div class="h4 font-weight-bold">{{customer.totalConversion.length > 0 ?
                          numeral(customer.totalConversion.reduce((acc, curr) => acc + curr.totalRefundedAmount,
                            0)).format('0,0.00') + ' TL' : '-'}}</div>
                      </div>
                      <div class="col-4">
                        <small>Toplam Yüklenen Bonus</small>

                        <div class="h4 font-weight-bold">{{customer.reportBonus.length > 0 ?
                          numeral(customer.reportBonus.filter(item => ['BONUS_DELAYED_REWARDED', 'BONUS_DEPOSIT',
                            'BONUS_GIFT',
                            'BONUS_DEPOSIT_TO_BANK'].includes(item.bonusType)).reduce((acc, curr) => Number(acc) +
                              Number(curr.amount),
                              0)).format('0,0.00') +
                          ' TL' : ' - '
                        }}
                        </div>
                        <div class="mt-5" v-if="selectedTimePeriod === 'monthly'">
                          <small class="font-weight-bold">Aylık Toplam Çevirim üzerinden Yüklenmesi Gereken
                            Bonus</small>
                          <div class="font-weight-bold h4 mt-1 mb-0 pb-0 mb-2 text-danger">
                            {{ numeral(customer.monthlyBonus).format('0,0.00') }} TL
                          </div>
                          <span class="pt-2 mt-3 text-muted">* {{ customer.monthlyBonusRate }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Haftalık Detaylar -->
                <div class="col-12">
                  <label style="font-weight: bold; color: black;">Haftalık Detaylar</label>
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr class="text-center">
                          <th class="text-center font-weight-bold">Hafta</th>
                          <th class="text-center font-weight-bold">Yükleme</th>
                          <th class="text-center font-weight-bold">NET Çevirim</th>
                          <th class="text-center font-weight-bold">Bonus Oranı</th>
                          <th class="text-center font-weight-bold">Bonus Miktarı</th>
                          <th class="text-center font-weight-bold">Durum</th>
                          <th class="text-center font-weight-bold">İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr v-for="(bonus, index) in customer.reportBonus" :key="index" :class="{
                          'table-success': ['DELAYED_BONUS_REWARDED', 'BONUS_DEPOSIT_TO_BANK', 'BONUS_GIFT', 'BONUS_DEPOSIT', 'BONUS_DELAYED_REWARDED'].includes(bonus.bonusType),
                          'table-danger': ['NOT_REWARDED'].includes(bonus.bonusType),
                          'table-warning': ['PENDING_LOADING', 'BONUS_DELAYED', 'PENDING'].includes(bonus.bonusType)
                        }">
                          <td>{{ bonus.reportTitle }}</td>
                          <td>{{numeral(customer.totalDeposit.find(item => item.reportId ===
                            bonus.report).totalAmount).format('0,0.00')}} TL</td>
                          <td>{{numeral(customer.totalConversion.find(item => item.reportId ===
                            bonus.report).totalAmount - customer.totalConversion.find(item => item.reportId ===
                              bonus.report).totalRefundedAmount).format('0,0.00')}} TL</td>

                          <td>{{ bonus.bonusRate }}</td>
                          <td>
                            <input type="number" class="form-control form-control-sm" v-model="bonus.amount"
                              :disabled="['BONUS_DEPOSIT', 'BONUS_GIFT', 'BONUS_DELAYED', 'BONUS_DEPOSIT_TO_BANK'].includes(bonus.bonusType)">
                          </td>
                          <td>
                            <select class="form-control form-control-sm" v-model="bonus.bonusType">
                              <option value="PENDING">İşlem Bekliyor</option>
                              <option value="NOT_REWARDED">Bonus Hakediş Yok</option>
                              <option value="PENDING_LOADING">Bonus Yüklenmesi Bekleniyor</option>
                              <option value="BONUS_DEPOSIT">Bonus Bakiye Yüklendi</option>
                              <option value="BONUS_GIFT">Bonus Hediye Olarak Verildi</option>
                              <option value="BONUS_DELAYED">Haftaya Devir</option>
                              <option value="DELAYED_BONUS_REWARDED">Sonraki Hafta Ödemesi Yapıldı</option>
                              <option value="BONUS_DEPOSIT_TO_BANK">Müşterinin Bankasına Yüklendi</option>
                            </select>
                          </td>
                          <td class="" style="height: 70px;">
                            <button @click="updateBonus(customer, bonus)"
                              class="btn btn-sm btn-fill btn-primary mr-1 font-weight-bold">Kaydet</button>
                            <button
                              v-if="['BONUS_DEPOSIT', 'BONUS_GIFT', 'BONUS_DELAYED', 'BONUS_DEPOSIT_TO_BANK'].includes(bonus.bonusType)"
                              @click="takeBonusPhoto(customer, bonus)"
                              class="btn btn-sm btn-fill btn-success font-weight-bold">
                              Paylaş
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>


          </card>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";
import moment from 'moment';
import numeral from 'numeral';

import logo from '../../assets/logo-dark.png';

const statusesMap = {
  'active': 'Aktif',
  'sold': 'Satıldı',
  'pending': 'Beklemede',
  'inactive': 'Pasif',
  'rented': 'Kiralandı',
  'maintenance': 'Tamirde',
  'other': 'Diğer',
}

export default {
  components: {
    Card
  },
  data() {
    return {
      customers: [],
      dealers: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10000,
        layOutMax: 3
      },
      queryText: '',
      searchInterval: null,
      statusesMap,
      selectedDealerId: null,
      numeral,
      weeks: [],
      months: [],
      selectedWeek: null,
      customersLoading: true,
      timePeriods: [
        { id: "weekly", title: 'Haftalık' },
        { id: "monthly", title: 'Aylık' }
      ],
      selectedTimePeriod: "weekly"
    }
  },
  mounted() {
    this.generateWeeks();
    this.generateMonths();
    this.getDealers();

    setTimeout(() => {
      this.getCustomers();
    }, 1000);
  },
  methods: {
    getCustomers() {
      let q = {
        $or: [
          { gsm: { $regex: this.queryText, $options: 'i' } },
          { fullPhone: { $regex: this.queryText, $options: 'i' } },
          { name: { $regex: this.queryText, $options: 'i' } },
          { surname: { $regex: this.queryText, $options: 'i' } }
        ]
      };


      let p = {};
      let o = { skip: 0, limit: 10000, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      if (this.selectedDealerId) {
        query += `&dealerId=${this.selectedDealerId}`;
      }
      if (this.selectedWeek && this.selectedTimePeriod === 'weekly') {
        query += `&week=${this.selectedWeek}`;
      }
      if (this.selectedMonth && this.selectedTimePeriod === 'monthly') {
        query += `&month=${this.selectedMonth}`;
      }

      query += `&isBonusPage=true&timePeriod=${this.selectedTimePeriod}`;

      this.customersLoading = true;
      CollectionService.getCollection('customer', query).then((res) => {
        if (res.success == true) {

          res.customers.forEach(customer => {

            if (customer.reportBonus) {
              this.calculateBonus(customer);
            }
          });

          this.customers = res.customers;

          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      }).finally(() => {
        this.customersLoading = false;
      })
    },
    editCustomer(_id) {
      this.$router.push(`/admin/customers/${_id}`);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    debounceGetCustomers() {
      if (this.searchInterval) {
        clearTimeout(this.searchInterval);
      }
      this.searchInterval = setTimeout(() => {
        this.getCustomers();
      }, 250);
    },
    selectDealer(dealerId) {
      this.selectedDealerId = dealerId;
      this.getCustomers();
    },
    selectTimePeriod(timePeriod) {
      this.selectedTimePeriod = timePeriod;
      this.getCustomers();
    },
    generateWeeks() {
      const weeks = [];
      let currentDate = new Date();

      // Find the most recent Tuesday
      while (currentDate.getDay() !== 2) { // 2 represents Tuesday
        currentDate.setDate(currentDate.getDate() - 1);
      }

      // Generate 12 weeks
      for (let i = 0; i < 36; i++) {
        const endDate = new Date(currentDate);
        const startDate = new Date(currentDate);
        startDate.setDate(startDate.getDate() - 7); // Go back 6 days for the previous Tuesday

        const formattedStartDate = startDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        const formattedEndDate = endDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });

        weeks.push({
          id: i,
          title: `${formattedStartDate} - ${formattedEndDate}`,
          startDate: startDate,
          endDate: endDate,
          value: moment(startDate).format('DDMMYYYY')
        });

        // Move to the previous week
        currentDate.setDate(currentDate.getDate() - 7);
      }

      this.weeks = weeks;
      this.selectedWeek = this.weeks[0].value; // Select the most recent week by default
    },
    generateMonths() {
      const months = [];
      let currentDate = new Date();

      // Set to the end of current month
      currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

      // Generate 12 months
      for (let i = 0; i < 12; i++) {
        const endDate = new Date(currentDate);
        const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // First day of month

        const formattedStartDate = startDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        const formattedEndDate = endDate.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });

        months.push({
          id: i,
          title: `${formattedStartDate} - ${formattedEndDate}`,
          startDate: startDate,
          endDate: endDate,
          value: moment(startDate).format('DDMMYYYY')
        });

        // Move to the previous month
        currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
      }

      this.months = months;
      this.selectedMonth = this.months[0].value; // Select the most recent month by default
    },
    getDealers() {
      let q = {};
      let p = {};
      let o = { skip: 0, limit: 10000, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('dealer', query).then((res) => {
        this.dealers = res.dealers;
      })
    },
    calculateBonus(customer) {

      if (!customer.reportBonus || customer.reportBonus.length === 0) {
        return;
      }

      console.log({ customer })
      const [length1, length2, length3] = [customer.reportBonus.length, customer.totalConversion.length, customer.totalDeposit.length];
      // Check if all lengths are equal
      const lengths = [length1, length2, length3];
      const allEqual = lengths.every(len => len === lengths[0]);

      console.log({ lengths })


      if (!allEqual) {
        console.error('Length mismatch detected:', {
          reportBonus: length1,
          totalConversion: length2,
          totalDeposit: length3
        });
        return;
      }

      customer.reportBonus.forEach(reportBonusItem => {



        const reportId = reportBonusItem.report;

        const totalConversion = customer.totalConversion.find(item => item.reportId === reportId);
        const totalDeposit = customer.totalDeposit.find(item => item.reportId === reportId);
        const reportTitle = totalConversion.reportTitle.split('_')[1].split('.')[0];
        reportBonusItem.reportTitle = `${reportTitle.slice(0, 2)}-${reportTitle.slice(2, 4)}-${reportTitle.slice(4, 8)}`;

        const netConversion = totalConversion.totalAmount - totalConversion.totalRefundedAmount;

        const rangeDealer = customer.dealer.bonusSettings.find(range => range.minCover <= netConversion && range.maxCover >= netConversion);
        const rangeCustomer = customer.bonusSettings.find(range => range.minCover <= netConversion && range.maxCover >= netConversion);
        const rangeGroup = customer.affiliateGroup && customer.affiliateGroup.bonusSettings.find(range => range.minCover <= netConversion && range.maxCover >= netConversion);

        let range = rangeCustomer || rangeGroup || rangeDealer;


        if (range) {
          reportBonusItem.totalConversionBonus = Math.round(((netConversion) * (range.bonusRate / 100)), 0);
        } else {
          reportBonusItem.bonusRate = "Bonus Limitine Girmedi.";
          reportBonusItem.totalConversionBonus = reportBonusItem.amount || 0;
          reportBonusItem.amount = reportBonusItem.amount || 0;
        }

        if (range && rangeCustomer) {
          reportBonusItem.bonusRate = "Müşteri Özel Bonus %" + range.bonusRate.toFixed(2);
        } else if (range && rangeGroup) {
          reportBonusItem.bonusRate = "Grup Özel Bonus %" + range.bonusRate.toFixed(2);
        } else if (range && rangeDealer) {
          reportBonusItem.bonusRate = "Bayii Üzerinden Bonus %" + range.bonusRate.toFixed(2);
        };

        if (reportBonusItem.bonusType == 'PENDING') {

          if (reportBonusItem.totalConversionBonus > 0) {
            reportBonusItem.bonusType = 'PENDING_LOADING';
            reportBonusItem.amount = reportBonusItem.totalConversionBonus;
          } else {
            reportBonusItem.bonusType = 'NOT_REWARDED';
          }
        };
        
      });

      if (this.selectedTimePeriod === 'monthly') {
        const montlyConversion = customer.totalConversion.reduce((acc, curr) => acc + (curr.totalAmount - curr.totalRefundedAmount), 0);

        const rangeDealer = customer.dealer.bonusSettings.find(range => range.minCover <= montlyConversion && range.maxCover >= montlyConversion);
        const rangeCustomer = customer.bonusSettings.find(range => range.minCover <= montlyConversion && range.maxCover >= montlyConversion);
        const rangeGroup = customer.affiliateGroup.bonusSettings.find(range => range.minCover <= montlyConversion && range.maxCover >= montlyConversion);



        let range = rangeCustomer || rangeGroup || rangeDealer;



        if (range && rangeCustomer) {
          customer.monthlyBonus = Math.round((montlyConversion * (range.bonusRate / 100)), 0);
          customer.monthlyBonusRate = "Müşteri Özel Bonus %" + range.bonusRate.toFixed(2);
        } else if (range && rangeGroup) {
          customer.monthlyBonus = Math.round((montlyConversion * (range.bonusRate / 100)), 0);
          customer.monthlyBonusRate = "Grup Özel Bonus %" + range.bonusRate.toFixed(2);
        } else if (range && rangeDealer) {
          customer.monthlyBonus = Math.round((montlyConversion * (range.bonusRate / 100)), 0);
          customer.monthlyBonusRate = "Bayii Özel Bonus %" + range.bonusRate.toFixed(2);
        } else {
          customer.monthlyBonus = 0;
          customer.monthlyBonusRate = "Bonus Limitine Girmedi.";

        }
      }



    },
    updateBonus(customer, bonus) {
      const payload = {
        customerId: customer._id,
        bonusType: bonus.bonusType,
        amount: bonus.amount,
        reportId: bonus.report,
        bonusId: bonus._id
      }
      CollectionService.postWidthAuth('customer/updateBonus', payload).then((res) => {
        if (res.success == true) {
          this.refreshSingleCustomer(customer._id);
          this.notifyVue('bottom', 'right', 'success', 'Bonus başarıyla güncellendi.');
        } else {
          this.notifyVue('bottom', 'center', 'danger', res.message);
        }
      })
    },
    refreshSingleCustomer(customerId) {
      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      query += `&customerIdList=${customerId}`;

      if (this.selectedWeek && this.selectedTimePeriod === 'weekly') {
        query += `&week=${this.selectedWeek}`;
      }
      if (this.selectedMonth && this.selectedTimePeriod === 'monthly') {
        query += `&month=${this.selectedMonth}`;
      }

      query += `&isBonusPage=true&timePeriod=${this.selectedTimePeriod}`;

      CollectionService.getCollection('customer', query).then((res) => {
        if (res.success == true && res.customers.length > 0) {
          const updatedCustomer = res.customers[0];
          
          if (updatedCustomer.reportBonus) {
            this.calculateBonus(updatedCustomer);
          }

          // Find and update the customer in the existing list
          const customerIndex = this.customers.findIndex(c => c._id === customerId);
          if (customerIndex !== -1) {
            this.$set(this.customers, customerIndex, updatedCustomer);
          }
        }
      })
    },
    takeBonusPhoto(customer, bonus) {
      const canvas = document.createElement('canvas');
      canvas.width = 1920;
      canvas.height = 1080;
      const ctx = canvas.getContext('2d');

      // Logo görüntüsünü yükle
      const logoImg = new Image();
      logoImg.src = logo;

      // Logo yüklendiğinde çizimi tamamla
      logoImg.onload = () => {
        // Koyu arka plan
        ctx.fillStyle = '#1E2026';  // Binance koyu arka plan rengi
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // Gradient efekti ekle
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, 'rgba(30, 32, 38, 1)');
        gradient.addColorStop(1, 'rgba(30, 32, 38, 0.8)');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);


        // "Lucky Shop Haftalık Bonus" başlığı
        ctx.font = 'bold 72px Arial';
        ctx.fillStyle = '#F0B90B'; // Sarı renk
        ctx.fillText('Lucky Shop Haftalık Bonus', 100, 120);

        // İşlem detayları
        ctx.font = 'bold 48px Arial';
        ctx.fillStyle = '#11A97D';  // Yeşil renk
        ctx.fillText(this.weeks.find(week =>
          week.value === this.selectedWeek).title, 100, 220);

        // Ana değer
        ctx.font = 'bold 180px Arial';
        ctx.fillStyle = '#11A97D';
        ctx.fillText(`${numeral(bonus.amount).format('0,0.00')} TL`, 100, 400);

        // Detay bilgileri
        const detailsStartY = 550;
        const lineHeight = 70;
        ctx.font = '36px Arial';
        ctx.fillStyle = '#ffffff';

        // Bilgileri daha profesyonel bir şekilde göster
        // Key-value çiftleri tanımla
        const detailsMap = {
          'Telefon': customer.gsm,
          'Toplam Çevirim': `${numeral(customer.totalConversion.find(item => item.reportId === bonus.report).totalAmount).format('0,0.00')} TL`,
          'Bonus Oranı': bonus.bonusRate
        };

        let currentY = detailsStartY;

        // Her bir key-value çifti için
        for (const [key, value] of Object.entries(detailsMap)) {
          // Sağ tarafta değer kutusu
          ctx.fillStyle = '#1E2026';
          ctx.fillRect(420, currentY - 30, 600, 50);

          // Key (sol taraf)
          ctx.fillStyle = '#848E9C'; // Gri renk
          ctx.fillText(`${key}:`, 120, currentY);

          // Value (sağ taraf)
          ctx.fillStyle = '#ffffff'; // Beyaz renk
          ctx.fillText(value, 440, currentY);

          currentY += lineHeight;
        }

        // Alt bilgi çizgisi
        ctx.strokeStyle = '#2B2F36';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(100, canvas.height - 200);
        ctx.lineTo(canvas.width - 100, canvas.height - 200);
        ctx.stroke();

        // Sol alt - Tarih
        ctx.font = '24px Arial';
        ctx.fillStyle = '#848E9C';
        ctx.fillText(new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }), 100, canvas.height - 50);


        // Web site adresi - önce yazıyı çizelim
        ctx.textAlign = 'right';
        ctx.font = '24px Arial';
        ctx.fillStyle = '#FFFFFF'; // Beyaz renk
        ctx.fillText('www.luckyshop.com.tr', canvas.width - 100, canvas.height - 20);
        // Logo çizimi - URL'nin hemen üstüne

        const logoWidth = 232.5;
        const logoHeight = 150;
        const logoX = canvas.width - 310;
        const logoY = canvas.height - 185;
        ctx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);

        /*    // Lucky Shop yazısı - logonun altına
           ctx.textAlign = 'right';
           ctx.font = 'bold 36px Arial';
           ctx.fillStyle = '#F0B90B';
           ctx.fillText('Lucky Shop', canvas.width - 100, canvas.height - 55); */

        // Reset text alignment
        ctx.textAlign = 'left';

        // İndir
        const image = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        const weekName = `${this.selectedWeek[0]}${this.selectedWeek[1]}.${this.selectedWeek[2]}${this.selectedWeek[3]}.${this.selectedWeek[4]}${this.selectedWeek[5]}${this.selectedWeek[6]}${this.selectedWeek[7]}`;
        link.download = `bonus_ozet_${weekName}_${customer.gsm}.png`;
        link.href = image;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    }
  }
}
</script>
<style></style>
